<template>
  <component :is="TypeComponent[type]" />
</template>

<script setup>
import { PayPromiseReportTypes } from "@/app/reports/utils/enums";

import Ranking from "./Ranking.vue";
import Progress from "./Progress.vue";
import List from "./List.vue";

const TypeComponent = {
  [PayPromiseReportTypes.Ranking]: Ranking,
  [PayPromiseReportTypes.Progress]: Progress,
  [PayPromiseReportTypes.List]: List,
};

defineProps({
  type: Number,
});
</script>

<style lang="sass" scoped></style>
